




































































































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
  computed,
  watch,
} from '@vue/composition-api'

import { uploadMediaItems } from '@/shared/api'
import { Textbook } from '@/shared/types'
import { alertSymbol, licensesSymbol } from '@/shared/state-management/symbols'
import CloseButton from '@/components/custom/CloseButton.vue'
import AddLinks from './AddLinks.vue'
export default defineComponent({
  name: 'UploadMediaItem',
  components: {
    CloseButton,
    AddLinks,
  },
  props: {
    textbook: Object,
  },
  setup(props, { root, emit }) {
    const MediaUploadForm = ref(null)
    const data = reactive({
      valid: true,
      name: '',
      files: [],
      fileNames: [],
      links: [],
      type: '',
      category: null,
      licenses: [],
      isDownloadable: false,
    })

    const dragover = ref(false)

    const $alert = inject(alertSymbol) as Function
    const availableLicenses = inject(licensesSymbol) as { value: Array<string> }
    const availableTypes = computed(() => [
      {
        label: root.$t('mediaItem.type.automatic'),
        value: '',
      },
      {
        label: root.$t('mediaItem.type.audio'),
        value: 'audio',
      },
      {
        label: root.$t('mediaItem.type.video'),
        value: 'video',
      },
      {
        label: root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: root.$t('mediaItem.type.image'),
        value: 'image',
      },
      {
        label: root.$t('mediaItem.type.excel'),
        value: 'excel',
      },
      {
        label: root.$t('mediaItem.type.word'),
        value: 'word',
      },
      {
        label: root.$t('mediaItem.type.zip'),
        value: 'zip',
      },
      {
        label: root.$t('mediaItem.type.other'),
        value: 'other',
      },
    ])

    const computedFilenames = computed(() => {
      return data.files.map((file: File) => file.name)
    })
    watch(computedFilenames, (newVal: string[]) => {
      newVal.forEach((filename) => {
        const index = data.fileNames.findIndex((el) => el.filename === filename)
        if (!(index >= 0)) {
          data.fileNames.push({ filename, name: '' })
        }
      })
    })

    const rules = reactive({
      nameRules: [
        (v: string) => !!v || root.$t('mediaItem.form.error.nameRequired'),
        () =>
          data.files.length > 0 ||
          data.links.length > 0 ||
          root.$t('mediaItem.form.error.filesRequired'),
      ],
      filesRules: [
        () =>
          data.files.length > 0 ||
          data.links.length > 0 ||
          root.$t('mediaItem.form.error.filesRequired'),
      ],
      linkRules: [
        (v: string) => {
          let isValid = true
          try {
            const link = new URL(v)
          } catch (e) {
            isValid = false
          }
          return isValid || root.$t('mediaItem.form.error.linkInvalid')
        },
      ],
    })
    const loadingData = ref(false)
    const addDropFile = (e: DragEvent) => {
      dragover.value = false
      // to support drag and drop https://github.com/vuetifyjs/vuetify/issues/7836#issuecomment-582841222
      data.files = Array.from(e.dataTransfer.files)
    }
    const addLink = () => {
      data.links.push({ url: '', name: '' })
    }

    const deleteLink = (index: number): void => {
      data.links.splice(index, 1)
    }

    const deleteFile = (filename: string) => {
      const index = data.files.findIndex((el) => el.name === filename)
      if (index >= 0) {
        data.files.splice(index, 1)
        const filenameIndex = data.fileNames.findIndex(
          (el) => el.filename === filename
        )
        data.fileNames.splice(filenameIndex, 1)
      }
    }

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = MediaUploadForm.value
      if (!form.validate()) {
        return
      }

      loadingData.value = true
      try {
        const combinedFiles = data.files.map((el: File) => ({
          file: el,
          name: data.fileNames.find(
            (filenameItem: { filename: string; name: string }) =>
              filenameItem.filename === el.name
          )?.name,
        }))
        await uploadMediaItems(
          combinedFiles,
          data.links,
          (props.textbook as Textbook).id,
          data.type,
          data.category,
          data.licenses,
          data.isDownloadable
        )
        emit('media-items-uploaded')
        $alert({
          text: root.$t('mediaItem.uploaded', {
            number: data.files.length + data.links.length,
          }),
          type: 'success',
        })
        loadingData.value = false
      } catch (error) {
        loadingData.value = false
        throw error
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      loadingData,
      addDropFile,
      MediaUploadForm,
      submit,
      addLink,
      deleteLink,
      dragover,
      availableLicenses,
      availableTypes,
      computedFilenames,
      deleteFile,
    }
  },
})
